import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';

@Mixin
class ColumnOrderMixin extends Vue {

    protected tableColumnOrder = {
        dbName: '',
        orderDirection: 0,
    };
    protected tableColumnOrderForAjax = {
        dbName: '',
        orderDirection: 0,
    };

    public columnOrderFetchList() {
        // tslint:disable-next-line:no-console
        console.log('Implement me calling columnOrderOnFetchSuccess when promise resolves!');
    }

    protected composeOrdering() {
        let ordering = '';
        if ( this.tableColumnOrderForAjax.orderDirection !== 0 ) {
            ordering = this.tableColumnOrderForAjax.dbName;
            if ( this.tableColumnOrderForAjax.orderDirection === -1 ) {
                ordering = ordering.split( ',' ).
                    map((dbName) => {
                        if ( ordering.indexOf( '-' ) !== -1 ) {
                            return dbName.replace( '-', '' );
                        } else {
                            return '-' + dbName;
                        }
                    } ).join( ',' );
            }
        }
        return ordering;
    }

    protected orderDirectionColumn( dbName: string ) {
        let result = 0;
        if ( this.tableColumnOrder.dbName === dbName ) {
            result = this.tableColumnOrder.orderDirection;
        }
        return result;
    }

    protected columnOrderOnFetchSuccess() {
        this.tableColumnOrder.dbName = this.tableColumnOrderForAjax.dbName;
        this.tableColumnOrder.orderDirection = this.tableColumnOrderForAjax.orderDirection;
    }

    protected handleTableColumnOrderChange( columnDbName: string, newOrderDirection: number ) {
        this.tableColumnOrderForAjax.dbName = columnDbName;
        this.tableColumnOrderForAjax.orderDirection = newOrderDirection;
        this.columnOrderFetchList();
    }

}

export default ColumnOrderMixin;
